import { getUserInfo } from "../utils/login";

export default {
  /**初始化数据模型 */
  async initStore({ state, commit }) {
    state.initing = true;
    const userInfo = await getUserInfo();

    if (userInfo) {
      commit("setUserInfo", userInfo);
    }

    state.initing = false;
  },
};
